<template>
  <tbody>
    <tr class="component">
      <td class="title">{{ component.title }}</td>
      <td class="hours" colspan="2">{{ totalHours }}</td>
      <td class="amount" colspan="2">{{ totalHours * quoteParams.rate | currency }}</td>
      <td class="amount" colspan="2">{{ totalHours * quoteParams.optionalRate | currency }}</td>
    </tr>
    <tr>
      <td>Project Management</td>
      <td class="hours" colspan="2">{{ pmHours }}</td>
      <td class="amount" colspan="2">{{ pmHours * quoteParams.rate | currency }}</td>
      <td class="amount" colspan="2">{{ pmHours * quoteParams.optionalRate | currency }}</td>
    </tr>
    <tr v-for="itemType in itemTypes" v-if="component[itemType.value] > 0">
      <td>{{ itemType.label }}</td>
      <td class="hours" colspan="2">{{ component[itemType.value] }}</td>
      <td class="amount" colspan="2">{{ component[itemType.value] * quoteParams.rate | currency }}</td>
      <td class="amount" colspan="2">{{ component[itemType.value] * quoteParams.optionalRate | currency }}</td>
    </tr>
    <tr class="section">
      <td><strong>Sections</strong></td>
      <td class="center aligned">Total</td>
      <td class="center aligned">PM</td>
      <td class="center aligned">Total</td>
      <td class="center aligned">PM</td>
      <td class="center aligned">Total</td>
      <td class="center aligned">PM</td>
    </tr>
    <template v-for="section in component.sections">
      <tr>
        <td>{{ section.title }}</td>
        <td class="hours">{{ sectionTotalHours(section) }}</td>
        <td class="hours pm">{{ calcPmHours(section.hours) }}</td>
        <td class="amount">{{ sectionTotalHours(section) * quoteParams.rate | currency }}</td>
        <td class="amount pm">{{ calcPmHours(section.hours) * quoteParams.rate | currency }}</td>
        <td class="amount">{{ sectionTotalHours(section) * quoteParams.optionalRate | currency }}</td>
        <td class="amount pm">{{ calcPmHours(section.hours) * quoteParams.optionalRate | currency }}</td>
      </tr>
    </template>
  </tbody>
</template>

<script>
  import _ from 'lodash'

  export default {
    data () {
      return {}
    },

    props: ['component', 'quote-params'],

    computed: {
      totalHours () {
        return this.component.hours + this.pmHours
      },

      pmHours () {
        return this.calcPmHours(this.component.hours)
      },

      pmRatioPercent () {
        return this.quoteParams.pmRatio / 100
      },

      itemTypes () {
        return this.$store.getters.itemTypes
      }
    },

    methods: {
      calcPmHours: function (hours) {
        return _.ceil(hours * this.pmRatioPercent)
      },

      sectionTotalHours: function (section) {
        return section.hours + this.calcPmHours(section.hours)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .ui.table {
    tr.component td {
      background-color: #646464;
      color: #f0f0f0;
      font-weight: 700;
      padding: .92857143em .7em;
    }

    tr {
      &.section {
        background-color: #eee;
      }

      th,
      td {
        &.hours {
          text-align: center;
        }

        &.amount {
          text-align: right;
        }

        &.pm {
          background-color: transparentize(#daeaef, .5);
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// QuoteComponent.vue?64439215